module.exports = __webpack_public_path__ + "img/masonry.b9806cd4.png";